import { useScreen } from '../../../../../../../hooks'
import { FormikField } from '../../../../../../Formik'
import { TextareaInlineField } from '../../../../../../Textarea'

function TextInput({ card: { label, name, required }, fieldClassName }) {
  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      Component={TextareaInlineField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        className: fieldClassName,
        label,
        required,
        shouldAdaptToMobileScreen: true,
      }}
      name={name}
      placeholder={label}
    />
  )
}

export default TextInput
